<div
  *ngIf="showSpinner$ | async"
  class="d-flex align-items-center justify-content-center custom-loading-spinner"
>
  <cx-spinner></cx-spinner>
</div>
